// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-dropdown {
  /* Typography */
  --perxis-auto-dropdown-font-family-inner: var(
    --perxis-auto-dropdown-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dropdown-font-size-inner: var(
    --perxis-auto-dropdown-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dropdown-font-weight-inner: var(
    --perxis-auto-dropdown-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dropdown-letter-spacing-inner: var(
    --perxis-auto-dropdown-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dropdown-line-height-inner: var(--perxis-auto-dropdown-line-height, 1.5);
  --perxis-auto-dropdown-text-transform-inner: var(
    --perxis-auto-dropdown-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dropdown-font-variant-numeric-inner: var(
    --perxis-auto-dropdown-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-dropdown-menu-item-icon-font-size-inner: var(--perxis-auto-dropdown-menu-item-icon-font-size, inherit);
  /* End Typography */
  /* Border */
  --perxis-auto-dropdown-border-radius-inner: var(--perxis-auto-dropdown-border-radius, 8px);
  --perxis-auto-dropdown-border-width-inner: var(--perxis-auto-dropdown-border-width, 2px);
  /* End Border */
  /* Colors */
  --perxis-auto-dropdown-first-color-inner: var(
    --perxis-auto-dropdown-first-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-dropdown-second-color-inner: var(
    --perxis-auto-dropdown-second-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-dropdown-third-color-inner: var(
    --perxis-auto-dropdown-third-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-dropdown-fourth-color-inner: var(
    --perxis-auto-dropdown-fourth-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-dropdown-fifth-color-inner: var(
    --perxis-auto-dropdown-fifth-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-dropdown-sixth-color-inner: var(
    --perxis-auto-dropdown-sixth-color,
    var(--perxis-auto-root-tenth-color-inner)
  );
  /* End Colors */
  /* Z-index */
  --perxis-auto-dropdown-z-index-inner: var(--perxis-auto-dropdown-z-index, 1030);
  /* End Z-index */
  /* Padiing */
  --perxis-auto-dropdown-menu-item-padding-inner: var(--perxis-auto-dropdown-menu-item-padding, 6px 15px);
  /* End Padiing */
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_0-dropdown[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_0-dropdown > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_0-dropdown .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown {
  font-family: var(--perxis-auto-dropdown-font-family-inner);
  font-size: var(--perxis-auto-dropdown-font-size-inner);
  line-height: var(--perxis-auto-dropdown-line-height-inner);
  font-weight: var(--perxis-auto-dropdown-font-weight-inner);
  text-transform: var(--perxis-auto-dropdown-text-transform-inner);
  letter-spacing: var(--perxis-auto-dropdown-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-dropdown-font-variant-numeric-inner);
  color: var(--perxis-auto-dropdown-second-color-inner);
  z-index: var(--perxis-auto-dropdown-z-index-inner);
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-submenu {
  background: var(--perxis-auto-dropdown-first-color-inner);
  color: var(--perxis-auto-dropdown-second-color-inner);
  border-radius: var(--perxis-auto-dropdown-border-radius-inner);
  padding: 0;
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-item {
  flex-direction: row-reverse;
  justify-content: flex-end;
  gap: 10px;
  border-radius: 0;
  padding: var(--perxis-auto-dropdown-menu-item-padding-inner);
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-item:first-child {
  border-radius: var(--perxis-auto-dropdown-border-radius-inner) var(--perxis-auto-dropdown-border-radius-inner) 0 0;
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-item:last-child {
  border-radius: 0 0 var(--perxis-auto-dropdown-border-radius-inner) var(--perxis-auto-dropdown-border-radius-inner);
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-item * {
  flex: 0 0 auto;
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-item-icon {
  --perxis-auto-icon-font-size: var(--perxis-auto-dropdown-menu-item-icon-font-size-inner);
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-item,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-submenu-title {
  font-family: var(--perxis-auto-dropdown-font-family-inner);
  font-size: var(--perxis-auto-dropdown-font-size-inner);
  line-height: var(--perxis-auto-dropdown-line-height-inner);
  font-weight: var(--perxis-auto-dropdown-font-weight-inner);
  text-transform: var(--perxis-auto-dropdown-text-transform-inner);
  letter-spacing: var(--perxis-auto-dropdown-letter-spacing-inner);
  color: var(--perxis-auto-dropdown-second-color-inner);
}
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-item:hover,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-submenu .ant-5_17_0-dropdown-menu .ant-5_17_0-dropdown-menu-item:hover,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-submenu-title:hover,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-submenu .ant-5_17_0-dropdown-menu .ant-5_17_0-dropdown-menu-submenu-title:hover,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-item-active,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-submenu .ant-5_17_0-dropdown-menu .ant-5_17_0-dropdown-menu-item-active,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-submenu-title-active,
.perxis-auto-1_16_0-dropdown.ant-5_17_0-dropdown .ant-5_17_0-dropdown-menu-submenu .ant-5_17_0-dropdown-menu .ant-5_17_0-dropdown-menu-submenu-title-active {
  background: var(--perxis-auto-dropdown-fifth-color-inner);
  color: var(--perxis-auto-dropdown-second-color-inner);
}

.perxis-auto-1_16_0-dropdown-trigger {
  --perxis-auto-dropdown-trigger-font-family-inner: var(
    --perxis-auto-dropdown-trigger-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dropdown-trigger-font-size-inner: var(
    --perxis-auto-dropdown-trigger-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dropdown-trigger-font-weight-inner: var(
    --perxis-auto-dropdown-trigger-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dropdown-trigger-letter-spacing-inner: var(
    --perxis-auto-dropdown-trigger-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dropdown-trigger-line-height-inner: var(
    --perxis-auto-dropdown-trigger-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-dropdown-trigger-text-transform-inner: var(
    --perxis-auto-dropdown-trigger-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dropdown-trigger-font-variant-numeric-inner: var(
    --perxis-auto-dropdown-trigger-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-dropdown-trigger-icon-font-size-inner: var(--perxis-auto-dropdown-trigger-icon-font-size, inherit);
  --perxis-auto-dropdown-first-color-inner: var(
    --perxis-auto-dropdown-first-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-dropdown-second-color-inner: var(
    --perxis-auto-dropdown-second-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-dropdown-third-color-inner: var(
    --perxis-auto-dropdown-third-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-dropdown-fourth-color-inner: var(
    --perxis-auto-dropdown-fourth-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-dropdown-fifth-color-inner: var(
    --perxis-auto-dropdown-fifth-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-dropdown-sixth-color-inner: var(
    --perxis-auto-dropdown-sixth-color,
    var(--perxis-auto-root-tenth-color-inner)
  );
}
.perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger {
  font-family: var(--perxis-auto-dropdown-trigger-font-family-inner);
  font-size: var(--perxis-auto-dropdown-trigger-font-size-inner);
  line-height: var(--perxis-auto-dropdown-trigger-line-height-inner);
  font-weight: var(--perxis-auto-dropdown-trigger-font-weight-inner);
  text-transform: var(--perxis-auto-dropdown-trigger-text-transform-inner);
  letter-spacing: var(--perxis-auto-dropdown-trigger-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-dropdown-trigger-font-variant-numeric-inner);
}
.perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__title {
  display: none;
  color: var(--perxis-auto-dropdown-sixth-color-inner);
  cursor: pointer;
}
@media (min-width: 576px) {
  .perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__title {
    display: inline;
  }
}
.perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__value {
  cursor: pointer;
}
.perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__value, .perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__value .perxis-auto-1_16_0-dropdown-trigger__icon,
.perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__value .perxis-auto-1_16_0-dropdown-trigger__label {
  display: inline-flex;
  align-items: center;
}
.perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__value .perxis-auto-1_16_0-dropdown-trigger__icon {
  margin-left: 4px;
  color: var(--perxis-auto-dropdown-fourth-color-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-dropdown-trigger-icon-font-size-inner);
}
.perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__value .perxis-auto-1_16_0-dropdown-trigger__icon svg {
  fill: var(--perxis-auto-dropdown-fourth-color-inner);
}
.perxis-auto-1_16_0-dropdown-trigger.ant-5_17_0-dropdown-trigger .perxis-auto-1_16_0-dropdown-trigger__value .perxis-auto-1_16_0-dropdown-trigger__label {
  color: var(--perxis-auto-dropdown-second-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
